// components/BookingsTable.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/Tables.css";

const BookingsTable = () => {
  const [bookings, setBookings] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/bookings`);
        if (response.data.success && Array.isArray(response.data.bookings)) {
          setBookings(response.data.bookings); // ✅ only the array
        } else {
          setBookings([]); // fallback
        }
      } catch (error) {
        console.error("Error fetching bookings:", error);
      }
    };

    fetchBookings();
  }, []);

  const filtered = bookings.filter(
    (b) =>
      b.customer_name.toLowerCase().includes(search.toLowerCase()) ||
      b.project_name.toLowerCase().includes(search.toLowerCase()) ||
      b.customer_phone.includes(search)
  );

  return (
    <div className="table-container">
      <h3>Bookings</h3>
      <input
        type="text"
        placeholder="Search by name, project or phone..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <table>
        <thead>
          <tr>
            <th>No</th>
            <th>Project Name</th>
            <th>Plot Number</th>
            <th>Customer Name</th>
            <th>Customer Email</th>
            <th>Customer Phone</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((b, i) => (
            <tr key={b.id}>
              <td>{i + 1}</td>
              <td>{b.project_name}</td>
              <td>{b.plot_number}</td>
              <td>{b.customer_name}</td>
              <td>{b.customer_email}</td>
              <td>{b.customer_phone}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BookingsTable;
